import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Lấy danh sách bài viết (có phân trang + lọc trạng thái/danh mục/tiêu đề)
export const getArticles = createAsyncThunk(
  "article/getArticles",
  async ({ currentPage, pageSize, status, title, category }, { rejectWithValue }) => {
    try {
      let apiUrl = `/api/v1/serviceconnect/posts?has_paginate&size=${pageSize}&page=${currentPage}`;

      if (status) {
        apiUrl += `&status=${status}`;
      }
      if (title) {
        apiUrl += `&search=${title}`;
      }
      if (category) {
        apiUrl += `&category=${category}`;
      }

      const response = await http.get(apiUrl);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);

// Lấy chi tiết 1 bài viết theo id (cho trang chỉnh sửa)
export const getArticleById = createAsyncThunk(
  "article/getArticleById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.get(`/api/v1/serviceconnect/posts/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Không tải được bài viết");
    }
  }
);

export const deleteArticle = createAsyncThunk(
  "article/deleteArticle",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(
        `/api/v1/serviceconnect/posts/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const toggleArticleStatus = createAsyncThunk(
  "article/toggleArticleStatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.patch(
        `/api/v1/serviceconnect/posts/${id}/toggle-status`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addArticle = createAsyncThunk(
  "article/addArticle",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/posts`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateArticle = createAsyncThunk(
  "article/updateArticle",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await http.post(
        `/api/v1/serviceconnect/posts/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Upload ảnh chèn trong nội dung bài viết (rich-text editor) → trả về URL tuyệt đối
export const uploadArticleImage = createAsyncThunk(
  "article/uploadArticleImage",
  async (file, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("image", file);
      const response = await http.post(
        `/api/v1/serviceconnect/posts/upload-image`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);
